<ng-progress></ng-progress>

<!-- start of hero section -->
<section id="hero__section" class="scroll px-3" style="overflow: hidden; pointer-events: none !important;">
  <div class="coming-soon d-flex align-items-end flex-column bd-highlight mb-3 ml-auto" style="background: transparent; position: absolute; z-index: 1; pointer-events: none;">
    <img src="../../assets/img/coming_soon3.png" class="img-fluid" alt="" srcset="" width="300" height="300">
  </div>
  <div class="container-fluid mx-auto" style="overflow-y: hidden; z-index: -1;">
    <img src="../../assets/img/Logo.png" class="logo" alt="image" srcset="">
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-8 col-lg-8" style="overflow: hidden;">
        <div class="hero__text1 wow bounceIn">
          <h1>Be that <span class="super__hero">Superhero</span> that is Saved</h1>
          <div class="heading-underline"></div>
          <p>Keep track and control your alcohol consumption daily.</p>
        </div>
        <div class="hero__text2 wow bounceIn">
          <p>Be the first to get notified on app release below.</p>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-4 col-lg-4" style="overflow: hidden;">
        
        <div class="text-center wow pulse" style="overflow: hidden; animation-duration: 3s; animation-delay: 3s; animation-iteration-count: infinite;">
          <img src="../../assets/img/hero_beer.png" class="beer__phone wow bounceIn" alt="image" width="280" srcset="">
        </div>
      </div>
    </div>
  </div>
</section>
<!-- end of hero section -->

<!-- start of features1 section -->
<section id="features1" class="text-center scroll wow pulse">
  <div class="container-fluid mx-auto">
    <div class="features__logo__text">
      <div class="row  wow slideInLeft">
        <div class="col-12 col-sm-12 col-md-5 my-auto">
          <img src="../../assets/img/Logo.png" alt="image" srcset="">
        </div>
        <div class="col-12 col-sm-12 col-md-7 pl-3">
          <h1 class="text-left" style="overflow: hidden;"> <span> keeps your drink under
              check</span> </h1>
        </div>
      </div>
    </div>
    <div class="row d-flex justify-content-around wow bounce" style="animation-delay: 15s; animation-iteration-count: infinite; animation-duration: 6s;">
      <div class="col-12 col-sm-12 com-md-4 col-lg-4 text-center mx-auto" style="overflow: hidden;">
        <div class="card py-5 px-4 mx-auto wow rotateIn">
          <div class="card-img"><img src="../../assets/img/calculation_icon.png" class="img-fluid" height="129"
              width="133" alt="image" srcset=""></div>
          <div class="card-title">Content Calculation</div>
          <div class="card-text">
            Automatically provides drink content upon using the scan-to-recognize feature or when name of drink is
            voiced out at a bar or to a friend.
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 com-md-4 col-lg-4 text-center" style="overflow: hidden;">
        <div class="card py-5 px-4 mx-auto wow rotateIn">
          <div class="card-img"><img src="../../assets/img/bac_icon.png" class="img-fluid" height="129" width="133"
              alt="image" srcset="">
          </div>
          <div class="card-title">Estimate BAC</div>
          <div class="card-text">
            Estimates pervious blood alcoholic content and adds them up with the ‘proposed’ new intake. </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 com-md-4 col-lg-4 text-center" style="overflow: hidden;">
        <div class="card py-5 px-4 mx-auto wow rotateIn">
          <div class="card-img"><img src="../../assets/img/response_icon.png" class="img-fluid" height="129" width="133"
              alt="image" srcset="">
          </div>
          <div class="card-title">Gives Response</div>
          <div class="card-text">
            Gives responses regarding the test already carried out, and gives the possible damage to the body. It also
            suggests solutions where necessary. </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- end of features1 section -->

<!-- start of features2 section -->
<section id="features2" class="text-white scroll">
  <div class="container-fluid mx-auto">
    <h3 class="wow rollIn">Features</h3>
    <div class="heading-underline wow slideInLeft"></div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 wow slideInLeft" style="overflow: hidden;">
        <p class="paragraph1">We have provided some solutions to the alcohol comsumotion habit with
          these features which
          also limit drinking.
        </p>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-6">
        <div class="row wow slideInRight">
          <div class="col-6 col-sm-6 col-md-6 px-4 vectors">
            <div style="overflow-y: hidden;">
              <img src="../../assets/img/assistant_vector.png" class="assistant__vector" alt="image" srcset="">
              <img src="../../assets/img/assistant_vector2.png" class="assistant__vector2" alt="image" srcset="">
              <h4 class="assistant">Talk Assistant</h4>
              <p class="paragraph2">This help you to have discussions when in distress, and also talks to you when you
                are about to miss a
                streak.</p>
            </div>
            <div style="overflow-y: hidden;">
              <img src="../../assets/img/challenges_vector.png" class="challenges__vector" alt="image" srcset="">
              <img src="../../assets/img/challenges_vector2.png" class="challenges__vector2" alt="image" srcset="">
              <h4 class="challenges">Streak Challenges</h4>
              <p class="paragraph2">Helps you to stay dedicated to keeping off or reducing alcohol intake by going on
                periodal challenges.
              </p>
            </div>
            <div style="overflow-y: hidden;">
              <img src="../../assets/img/games_vector.png" class="games__vector" alt="image" srcset="">
              <img src="../../assets/img/games_vector2.png" class="games__vector2" alt="image" srcset="">
              <h4 class="games">Games</h4>
              <p class="paragraph2">Interestinig games to have fun with.</p>
            </div>
          </div>
          <div class="col-6 col-sm-6 col-md-6 px-4 vectors">
            <div style="overflow-y: hidden;">
              <img src="../../assets/img/screen_capture_vector.png" class="screen__capture__vector" alt="image"
                srcset="">
              <img src="../../assets/img/screen_capture_vector2.png" class="screen__capture__vector2" alt="image"
                srcset="">
              <h4 class="capture">On-screen capture</h4>
              <p class="paragraph2">Captures any drink anytime on seeing it in the user’s hand then scans it.</p>
            </div>
            <div style="overflow-y: hidden;">
              <img src="../../assets/img/translation_vector.png" class="translation__vector" alt="image" srcset="">
              <img src="../../assets/img/translation_vector2.png" class="translation__vector2" alt="image" srcset="">
              <h4 class="translation">Support Translation</h4>
              <p class="paragraph2">Supports different languages across the globe. Including voice translation.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- end of features2 section -->

<!-- start of product images section -->
<section id="product__images" class="text-center scroll">
  <h2 class="text-center d-flex justify-content-center wow bounceInDown" style="overflow-y: hidden;">Product Tour</h2>
  <div class="heading-underline mx-auto"></div>
  <div class="wrapper mb-5 mt-5" style="text-align: center;">
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <div style="display: inline-block;" style="overflow: hidden;" class="product__images_p">
          <p class="text-center wow fadeInUpBig">Product images to convince you on how the app looks like. Enjoy the
            product features
            and
            live a better life with ease.</p>
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>
  </div>
  <div class="container-fluid ml-auto mr-auto mt-5" style="text-align: center;">
    <!-- start of carousel -->
    <div id="carouselIndicators" class="carousel slide" data-ride="carousel" data-interval="5000">
      <ol class="carousel-indicators mt-5">
        <li data-target="#carouselIndicators" data-slide-to="0" class="active" style="fill: red"></li>
        <li data-target="#carouselIndicators" data-slide-to="1" style="fill: red"></li>
        <li data-target="#carouselIndicators" data-slide-to="2" style="fill: red"></li>
        <li data-target="#carouselIndicators" data-slide-to="3" style="fill: red"></li>
      </ol>
      <!-- start of carousel inner -->
      <div class="carousel-inner" role="listbox">
        <!-- start of first slide -->
        <div class="carousel-item active">
          <div class="row text-center">
            <div class="col-6 col-sm-6 col-md-6">
              <div class="text-center" style="overflow-y: hidden;">
                <img src="../../assets/img/screen1.png" height="600" width="300" alt="image" srcset=""
                  class="img-fluid white__rectangle popup wow flipInY" style="cursor: pointer;">
                <div class="screen__texts mt-5 mx-auto text-center">
                  <h3>Voice Capture</h3>
                  <p class="mt-3">Anytime a beer is mentioned, it responds automatically.</p>
                </div>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-6" style="overflow-y: hidden;">
              <img src="../../assets/img/screen2.png" height="600" width="300" alt="image" srcset=""
                class="img-fluid white__rectangle popup wow flipInY" style="cursor: pointer;">
              <div class="screen__texts mt-5">
                <h3>Screen Capture Feature</h3>
                <p class="mt-3">Able to scan to detect what beer you are taking at a particular time</p>
              </div>
            </div>
          </div>
        </div>
        <!-- end of first slide -->
        <!-- start of second slide -->
        <div class="carousel-item">
          <div class="row">
            <div class="col-6 col-sm-6 col-md-6">
              <img src="../../assets/img/screen3.png" height="600" width="300" alt="image" srcset=""
                class="img-fluid white__rectangle popup" style="cursor: pointer;">
              <div class="screen__texts mt-5">
                <h3>Manual Input Feature</h3>
                <p class="mt-3">You can input you favourite beer for records.</p>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-6">
              <img src="../../assets/img/screen4.png" height="600" width="300" alt="image" srcset=""
                class="img-fluid white__rectangle popup" style="cursor: pointer;">
              <div class="screen__texts mt-5">
                <h3>BAC Calculation Feature</h3>
                <p class="mt-3">Gets previous records of Alcohol taken and combines with the present.</p>
              </div>
            </div>
          </div>
        </div>
        <!-- end of second slide -->
        <!-- start of third slide -->
        <div class="carousel-item">
          <div class="row">
            <div class="col-6 col-sm-6 col-md-6">
              <img src="../../assets/img/screen5.png" height="600" width="300" alt="image" srcset=""
                class="img-fluid white__rectangle popup" style="cursor: pointer;">
              <div class="screen__texts mt-5">
                <h3>Response</h3>
                <p class="mt-3">Gives a feedback whether to proceed or withdraw from taking Alcohol.</p>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-6">
              <img src="../../assets/img/screen6.png" height="600" width="300" alt="image" srcset=""
                class="img-fluid white__rectangle popup" style="cursor: pointer;">
              <div class="screen__texts mt-5">
                <h3>Games Feature</h3>
                <p class="mt-3">All kinds of games to distract urges to take Alcohol.</p>
              </div>
            </div>
          </div>
        </div>
        <!-- end of third slide -->
      </div>
      <!-- end of carousel inner -->
      <!-- start of previous and next buttons -->
      <a href="#carouselIndicators" class="carousel-control-prev text-left" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      </a>
      <a href="#carouselIndicators" class="carousel-control-next" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
      </a>
      <!-- end of previous and next buttons -->
    </div>
    <!-- end of carousel -->
  </div>
</section>
<!-- end of product images section -->

<!-- start of coming soon section -->
<section id="notify" class="mt-5 pt-3 scroll">
  <div class="text-center wow bounceIn">
    <h2 class="text-center" style="overflow: hidden;">Launch coming soon!</h2>
    <p class="text-center mt-4 mx-auto">Sign up to get notified first</p>
    <div class="">
      <form [formGroup]="newsletterForm" (ngSubmit)="registerData()">
        <div class="form-group text-center">
          <input type="email" class="form-control mx-auto" formControlName="email" id="inputemail"
            aria-describedby="emailHelp" placeholder="Email address">
        </div>
        <div class="text-center mt-5 button__div">
          <button type="submit" class="btn btn-primary notify">Notify Me</button>
        </div>
      </form>
    </div>
  </div>
</section>
<!-- end of coming soon section -->

<!-- start of models sections -->
<section id="modals">
  <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-sm modal-dialog-centered mx-auto">
      <div class="modal-content">
        <img class="w-100 h-auto" id="popup-img" src="" alt="image" srcset="">
      </div>
    </div>
  </div>
</section>
<!-- end of models section -->

<!-- start of footer section -->
<section id="footer">
  <footer  style="overflow: hidden;">
    <div class="text-left wow rotateInUpLeft">
      <img src="../../assets/img/Logo3.png" alt="image" srcset="">
    </div>
    <div class="hr ml-auto wow slideInRight">
      <hr align="center">
    </div>
    <div class="copyright" style="overflow: hidden;">
      <p class="mx-auto  wow rotateInUpRight">
        <span class="iconify" data-icon="bx:bx-copyright" data-inline="false"></span>
        <span class="ml-4">2020 All rights reserved</span>
      </p>
    </div>
  </footer>
</section>
<!-- end of footer section -->